import { apiHelper } from "../../utils/api";
import { API_BASE_URL } from "../../utils/constants";

export async function queryAi(message, conversationId = null) {
  const payload = { message };
  if (conversationId) payload.conversationId = conversationId;
  const response = await apiHelper.post("/ai/query", payload);
  return response;
}

export async function queryAiStream(message, conversationId, onToken, onDone, onError) {
  const payload = { message };
  if (conversationId) payload.conversationId = conversationId;

  try {
    const response = await fetch(`${API_BASE_URL}/ai/query/stream`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include", // Send httpOnly cookie for auth
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      const body = await response.text().catch(() => "");
      const msg = `Server returned ${response.status}${body ? ": " + body.slice(0, 200) : ""}`;
      onError(msg);
      return;
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = "";
    let receivedValidEvent = false;

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      buffer += decoder.decode(value, { stream: true });
      const lines = buffer.split("\n");
      buffer = lines.pop() || "";

      for (const line of lines) {
        if (!line.trim()) continue;
        try {
          const data = JSON.parse(line);
          if (data.type === "token") {
            receivedValidEvent = true;
            onToken(data.text);
          } else if (data.type === "done") {
            receivedValidEvent = true;
            onDone(data.conversationId, data.aiPreferences, data.dailyUsed, data.dailyMax);
          } else if (data.type === "error") {
            receivedValidEvent = true;
            onError(data.userMessage || "Something went wrong", data.errorCode, { dailyUsed: data.dailyUsed, dailyMax: data.dailyMax });
          }
        } catch {
          // skip malformed lines
        }
      }
    }

    // Process remaining buffer
    if (buffer.trim()) {
      try {
        const data = JSON.parse(buffer);
        if (data.type === "done") {
          receivedValidEvent = true;
          onDone(data.conversationId, data.aiPreferences, data.dailyUsed, data.dailyMax);
        } else if (data.type === "error") {
          receivedValidEvent = true;
          onError(data.userMessage || "Something went wrong", data.errorCode, { dailyUsed: data.dailyUsed, dailyMax: data.dailyMax });
        }
      } catch {
        // ignore
      }
    }

    if (!receivedValidEvent) {
      onError("The server returned an unexpected response. Please try again.");
    }
  } catch (err) {
    onError(err?.message || "Network error. Please check your connection.");
  }
}

export async function getAiConversations() {
  return apiHelper.get("/ai/conversations");
}

export async function getAiConversation(id) {
  return apiHelper.get(`/ai/conversations/${id}`);
}

export async function deleteAiConversation(id) {
  return apiHelper.delete(`/ai/conversations/${id}`);
}

// AI Preferences
export async function getAiPreferences() {
  return apiHelper.get("/ai/preferences");
}

export async function updateAiPreferences(preferences) {
  return apiHelper.put("/ai/preferences", preferences);
}

export async function checkAiStatus() {
  return apiHelper.get("/ai/status");
}

export async function getAiDailyUsage() {
  return apiHelper.get("/ai/usage");
}
